import { store } from '../../../../resources/frontend/js/store/index';
import {validate, validateValue} from '../../js/vue-flows/default-components/sb-validate/v2/validate';

export const prefillAddress = async () => {
    const countryCode = store.state.page.countryCode;

    switch (countryCode) {
    case 'nl':
        return await prefillAddressNL();
    default:
        return true;
    }
};

export const prefillAddressNL = async () => {
    let houseNumberName = 'housenumber';
    let houseNumber = store.getters['form/getField']('housenumber');
    const huisNummer = store.getters['form/getField']('huisnummer');
    const zipcode = store.getters['form/getField']('zipcode');

    if (!houseNumber && huisNummer) {
        houseNumber = huisNummer;
        houseNumberName = 'huisnummer';
    }

    if (!houseNumber || !zipcode || !houseNumber.preValidate || !zipcode.preValidate) {
        return true;
    }

    const zipcode1 = zipcode.value.split(' ')[0];
    const zipcode2 = zipcode.value.split(' ')[1];

    const formData = new FormData();
    formData.append('country', 'nl');
    formData.append('zipcode1', zipcode1);
    formData.append('zipcode2', zipcode2);
    formData.append('housenumber', houseNumber.value);

    return await fetch(store.getters['page/getRoute']('address-by-zipcode'), {
        method: 'POST',
        body: formData,
    })
        .then(response => response.json())
        .then(response => {
            if (response.success === true) {
                const data = response.data;

                store.commit('form/addField', {
                    step: 0,
                    name: 'street',
                    data: {
                        dataType: 'Street',
                        value: data[0].straat,
                        preValidate: true,
                        validate: true,
                        validator: 'notEmpty',
                    },
                });

                store.commit('form/addField', {
                    step: 0,
                    name: 'city',
                    data: {
                        dataType: 'City',
                        value: data[0].woonplaats,
                        preValidate: true,
                        validate: true,
                        validator: 'notEmpty',
                    },
                });

                return true;
            } else {
                store.commit('form/setFieldData', {
                    name: houseNumberName,
                    key: 'preValidate',
                    value: false,
                });

                store.commit('form/setFieldData', {
                    name: houseNumberName,
                    key: 'validate',
                    value: false,
                });

                store.commit('form/setFieldData', {
                    name: 'zipcode',
                    key: 'preValidate',
                    value: false,
                });

                store.commit('form/setFieldData', {
                    name: 'zipcode',
                    key: 'validate',
                    value: false,
                });

                return false;
            }
        }).catch(() => {
            alert('Something went wrong, please try again. (2)');
            return false;
        });
};

export const prefillAddressBE = async => {
    const zipcode = store.state.user.location.zipcode;

    if (zipcode && validateValue(zipcode, 'zipcode')) {
        const formData = new FormData();
        formData.append('country', 'be');
        formData.append('zipcode1', zipcode);

        fetch(store.getters['page/getRoute']('address-by-zipcode'), {
            method: 'post',
            body: formData,
        })
            .then(response => response.json())
            .then(response => {
                if (response.success === true) {
                    const data = response.data;
                    const cities = [];

                    if (Array.isArray(data)) {
                        data.forEach(city => {
                            cities.push(city);
                        });
                    } else {
                        cities.push(data[0].plaats);
                    }

                    store.commit('form/setPrefillCity', {
                        valid: true,
                        cities,
                    });
                } else {
                    store.commit('form/setPrefillCity', { valid: false });
                }
            }).catch(() => {
                alert('Something went wrong, please try again. (2)');
            });
    }
};

export const prefillAddressFR = () => {
    const zipcode = store.state.user.location.zipcode;

    if (zipcode && validateValue(zipcode, 'zipcode')) {
        fetch('https://geo.api.gouv.fr/communes?codePostal=' + zipcode + '&fields=nom')
            .then(response => response.json())
            .then(response => {
                const cities = [];

                response.forEach(city => {
                    cities.push({ plaats: city.nom });
                });

                store.commit('form/setPrefillCity', {
                    valid: true,
                    cities,
                });
            })
            .catch(() => {
                alert('Something went wrong, please try again. (2)');
            });
    }
};
